import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-theme"]
const _hoisted_2 = {
  class: "scene-stage",
  "aria-label": "Portfólio de Vinicius Spanol"
}
const _hoisted_3 = ["data-page", "aria-label"]
const _hoisted_4 = { class: "page-dock" }
const _hoisted_5 = {
  class: "page-dock__context",
  "aria-live": "polite"
}
const _hoisted_6 = { class: "page-dock__index" }
const _hoisted_7 = { class: "page-dock__label" }
const _hoisted_8 = {
  class: "page-dock__progress",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  class: "page-dock__controls",
  "aria-label": "Navegar entre páginas"
}
const _hoisted_10 = ["disabled", "aria-label"]
const _hoisted_11 = ["disabled", "aria-label"]

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import HeaderComponent from "./components/HeaderComponent.vue";
import MatrixRain from "./components/MatrixRain.vue";
import { useTheme } from "./composables/useTheme";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { theme, isMatrix } = useTheme();
const prefersReducedMotion = ref(false);
const transitionName = ref("folio-forward");

const chapters = [
  { label: "Início", path: "/", name: "home" },
  { label: "Sobre", path: "/about", name: "about" },
  { label: "Projetos", path: "/projects", name: "projects" },
  { label: "Contato", path: "/contact", name: "contact" },
];

const chapterIndex = computed(() => {
  const current = chapters.findIndex((chapter) => chapter.name === String(route.name));
  return current < 0 ? 2 : current;
});
const currentPageNumber = computed(() => String(chapterIndex.value + 1).padStart(2, "0"));
const currentPageLabel = computed(() => chapters[chapterIndex.value].label);
const previousPage = computed(() => chapters[chapterIndex.value - 1]);
const nextPage = computed(() => chapters[chapterIndex.value + 1]);
const transitionDuration = computed(() =>
  prefersReducedMotion.value ? 0 : { enter: 680, leave: 680 },
);

let motionQuery: MediaQueryList | undefined;

function syncMotionPreference(event?: MediaQueryListEvent) {
  prefersReducedMotion.value = event?.matches ?? motionQuery?.matches ?? false;
}

function pageTitle(name: string | symbol | undefined) {
  const chapter = chapters.find((entry) => entry.name === String(name));
  return chapter?.label.toLowerCase() ?? "arquivo";
}

watch(
  () => route.name,
  (to, from) => {
    if (from == null) return;
    const order: Record<string, number> = {
      home: 0,
      about: 1,
      projects: 2,
      works: 2,
      contact: 3,
    };
    transitionName.value = (order[String(to)] ?? 0) >= (order[String(from)] ?? 0)
      ? "folio-forward"
      : "folio-backward";
  },
);

function preparePage(element: Element) {
  element.setAttribute("inert", "");
  element.setAttribute("aria-hidden", "true");
}

function deactivatePage(element: Element) {
  element.setAttribute("inert", "");
  element.setAttribute("aria-hidden", "true");
}

function focusPage(element: Element) {
  element.removeAttribute("inert");
  element.removeAttribute("aria-hidden");
  const heading = element.querySelector<HTMLElement>("h1, [data-page-focus]");
  if (!heading) return;
  heading.setAttribute("tabindex", "-1");
  heading.focus({ preventScroll: true });
}

function navigate(direction: -1 | 1) {
  const page = chapters[chapterIndex.value + direction];
  if (page) router.push(page.path);
}

onMounted(() => {
  motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  syncMotionPreference();
  motionQuery.addEventListener("change", syncMotionPreference);
});

onUnmounted(() => {
  motionQuery?.removeEventListener("change", syncMotionPreference);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "portfolio-site",
    "data-theme": _unref(theme)
  }, [
    (_unref(isMatrix) && !prefersReducedMotion.value)
      ? (_openBlock(), _createBlock(MatrixRain, { key: 0 }))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "portfolio-site__grain",
      "aria-hidden": "true"
    }, null, -1)),
    _createVNode(HeaderComponent),
    _createElementVNode("main", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "scene-stage__registration",
        "aria-hidden": "true"
      }, "EST. / SOFTWARE / BR", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "scene-stage__axis",
        "aria-hidden": "true"
      }, null, -1)),
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component, route: currentRoute }) => [
          _createVNode(_Transition, {
            name: transitionName.value,
            duration: transitionDuration.value,
            mode: "out-in",
            onBeforeEnter: preparePage,
            onAfterEnter: focusPage,
            onBeforeLeave: deactivatePage
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("div", {
                key: currentRoute.fullPath,
                class: "scene-page",
                "data-page": String(currentRoute.name),
                "aria-label": `Página ${pageTitle(currentRoute.name)}`,
                tabindex: "-1"
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 8, _hoisted_3))
            ]),
            _: 2
          }, 1032, ["name", "duration"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("footer", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode(_toDisplayString(currentPageNumber.value) + " ", 1),
          _cache[4] || (_cache[4] = _createElementVNode("i", null, "/ 04", -1))
        ]),
        _createElementVNode("span", _hoisted_7, _toDisplayString(currentPageLabel.value), 1)
      ]),
      _createElementVNode("ol", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chapters, (chapter, index) => {
          return _createElementVNode("li", {
            key: chapter.path,
            class: _normalizeClass({ 'page-dock__progress--active': index === chapterIndex.value })
          }, null, 2)
        }), 64))
      ]),
      _createElementVNode("nav", _hoisted_9, [
        _createElementVNode("button", {
          type: "button",
          disabled: chapterIndex.value === 0,
          "aria-label": `Ir para ${previousPage.value?.label ?? 'a página anterior'}`,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate(-1)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("span", { "aria-hidden": "true" }, "←", -1),
          _createElementVNode("span", { class: "page-dock__control-label" }, "ANTERIOR", -1)
        ]))], 8, _hoisted_10),
        _createElementVNode("button", {
          type: "button",
          disabled: chapterIndex.value === chapters.length - 1,
          "aria-label": `Ir para ${nextPage.value?.label ?? 'a próxima página'}`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate(1)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("span", { class: "page-dock__control-label" }, "PRÓXIMO", -1),
          _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
        ]))], 8, _hoisted_11)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})